import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import BaseMenu from "./BaseMenu";
import { SubMenuContainer } from "./styles";
var SubMenu = function(_param) {
    var children = _param.children, component = _param.component, options = _param.options, _isOpen = _param.isOpen, isOpen = _isOpen === void 0 ? false : _isOpen, props = _object_without_properties(_param, [
        "children",
        "component",
        "options",
        "isOpen"
    ]);
    return /*#__PURE__*/ _jsx(BaseMenu, {
        component: component,
        options: options,
        isOpen: isOpen,
        children: /*#__PURE__*/ _jsx(SubMenuContainer, _object_spread_props(_object_spread({}, props), {
            children: children
        }))
    });
};
export default SubMenu;
